module.exports = __webpack_public_path__ + "img/CBD-Salve-500mg.08246ac5.jpg";